import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>
      <p>
        By using this service, you agree to the following terms and conditions:
      </p>
      <ul>
        <li>
          You confirm that the files you upload do not contain any illegal, harmful, or malicious content.
        </li>
        <li>
          You agree that the files you upload do not violate any copyright, trademark, or other intellectual property rights.
        </li>
        <li>
          You are solely responsible for the content of the files you upload and any consequences of their use or distribution.
        </li>
        <li>
          You agree to comply with all applicable laws and regulations while using this service.
        </li>
        <li>
          The service provider is not liable for any misuse of the files uploaded through this platform.
        </li>
        <li>
          The service provider reserves the right to remove any files that violate these terms without prior notice.
        </li>
        <li>
          Uploaded files are stored temporarily and will be automatically deleted after the expiration time specified during the upload process.
        </li>
        <li>
          The service provider does not guarantee the availability of files beyond their expiration time.
        </li>
        <li>
          The service provider implements reasonable security measures to protect uploaded files.
        </li>
        <li>
          The service provider will not access, view, or use the content of the uploaded files in any way, except as necessary to provide the service (e.g., for file storage and delivery).
        </li>
      </ul>
      <p>
        If you do not agree to these terms, please do not use this service.
      </p>
    </div>
  );
};

export default Terms;
